module.exports = __webpack_public_path__ + "img/modern_isometric_illustration_design_hr.36e850c0.png";